<section class="section-online-check-content">
  <form [hidden]="!showDepositForm" [formGroup]="onlineCheckForm">
    <div >
      <p class="label tw-text-[16px]">Deposit Amount</p>
      <div class="amount-row tw-relative">

        <!-- Message section -->
        <span class="tw-absolute tw-top-[-18px] tw-right-[0px] tw-h-[18px] tw-block tw-pt-[2px]">

          <!-- Required -->
          <span
            class="tw-block tw-text-right tw-text-xs tw-text-[#D83A19]"
            *ngIf="formVal['amount'] && formVal['amount']?.errors
              && (formVal['amount'].touched || formVal['amount'].dirty)"
          >
            {{
              formVal['amount']?.errors?.['min']
                ? 'Cannot deposit less than $25.'
                : formVal['amount']?.errors?.['max']
                  ? 'Cannot deposit greater than $1000.'
                  : 'Please enter valid amount.'
            }}
          </span>
        </span>

        <input
          formControlName="amount"
          id="depositAmount"
          (keyup)="depositAmount()"
          type="number"
          min="25"
          max="1000"
          class="amount tw-h-[38px] tw-text-[22px] tw-text-[#645858]"
          placeholder="25"
          pattern="^\d+(\.\d{1,2})?$"
          amwager3DecimalInput
        />
      </div>
      <div class="tw-flex tw-mt-[6px] tw-mb-[22px] tw-justify-between">
        <span
          (click)="chooseAmount(500.00)"
          class="choose-amount tw-text-[16px]"
        >
          $500
        </span>
        <span
          (click)="chooseAmount(200.00)"
          class="choose-amount tw-text-[16px]"
        >
          $200
        </span>
        <span
          (click)="chooseAmount(100.00)"
          class="choose-amount tw-text-[16px]"
        >
          $100
        </span>
        <span
          (click)="chooseAmount(50.00)"
          class="choose-amount tw-text-[16px]"
        >
          $50
        </span>
        <span
          (click)="chooseAmount(25.00)"
          class="choose-amount tw-text-[16px]"
        >
          $25
        </span>
      </div>

      <div class="mid-line"></div>

      <div class="online-check-content">

        <p class="label tw-ml-[9px]">Choose Account: </p>
        <div class="online-check-list-container">
          <div class="online-check-lists">
            <div
              *ngIf="(accounts$ | async)| isEmpty"
              class="empty-account tw-pl-[8px] tw-pb-[20px]"
            >
              Please add account to deposit.
            </div>

            <div
              *ngFor="let account of accounts$ | async; let i = index"
              (click)="chooseAccount($event, 'achAccount', ('account-' + i), account.AccountId)"
              id="account-{{i}}"
              class="online-check-per-row tw-flex tw-w-full tw-justify-between tw-items-center"
            >
              <div class="tw-flex tw-items-center tw-w-[50%]">
                <span class="selector tw-flex"></span>

                <span class="online-check-name tw-text-[13px] tw-text-[#000000] tw-font-bold tw-ml-[8px]">
                  {{ account.AchName }}
                </span>
              </div>

              <div class="tw-flex tw-w-[20%]">
                <span class="online-check-ending tw-text-[12px]">
                  <span class="tw-font-bold tw-text-[#000000]">
                    {{ account.AchAccount.toString() | slice:-4 }}
                  </span>
                </span>
              </div>

              <div class="tw-flex">
                <ion-icon
                  (click)="confirmRemoveAccount(account.AccountId)"
                  name="trash-outline"
                  class="delete-online-check tw-text-[20px] tw-t-[-2px] tw-relative">
                </ion-icon>
              </div>
            </div>
          </div>
        </div>

      </div>

      <div class="online-check-container">
        <button
          (click)="openAddAccount()"
          class="add-online-check active tw-w-[100%] tw-h-[41px] tw-text-[16px] tw-mt-[15px]"
        >
          Add Account
        </button>
      </div>

      <p class="label tw-text-[16px]">Funds will be deposited:</p>

      <button
        (click)="deposit()"
        [ngClass]="
          {
            'active': (
              amount &&
              bankAccountId &&
              isAgree &&
              !isDepositing &&
              formVal['amount'].valid
            )
          }
        "
        [disabled]="
          !amount ||
          !bankAccountId ||
          !isAgree ||
          isDepositing ||
          formVal['amount'].invalid
        "
        type="submit"
        class="deposit-now tw-w-full tw-h-[41px] tw-text-[16px] tw-mt-[10px]"
      >
        Deposit Now
      </button>

      <div class="tw-mt-[15px]">
        <p class="tw-text-[15px]">
          By clicking Deposit Now, I agree to the Terms and Conditions of ACH Deposit.
          I understand my IP and location will be recorded for fraud prevention.
        </p>

        <p class="tw-text-[15px] tw-mt-[15px]">
          <span class="label tw-font-bold">Note:</span>
          Your current funding limit is ${{ customerFundingLimit | number:'1.2' }} and you have
          ${{ availableFundingLimit | number:'1.2' }} available.
        </p>

        <p class="tw-text-[15px] tw-mt-[15px]">
          I hereby authorize AmWager.com to initiate a debit, in the amount indicated,
          to my checking/savings account in the financial institution (Bank) identified by the routing number indicated,
          and bank to debit same to such account. I acknowledge that I have received services/goods in consideration hereof.
          I understand that I may revoke this authorization by contacting AmWager at support&#64;amwager.com on the same day of payment before 8 PM EST.
          I also agree to pay AmWager.com returned item fee of $25.00, for items returned unpaid.
        </p>
      </div>

      <div class="terms-and-condition-container tw-mt-[15px]">
        <ion-checkbox
          mode="md"
          [value]="isAgree"
          [checked]="isAgree"
          (ionChange)="toggleCheckbox()"
          id="termsAndCondition"
          class="active-limit tw-top-1 tw-mt-0 tw-mr-[4px] tw-mb-0">
        </ion-checkbox>
        <span
          (click)="toggleCheckbox()"
          class="agree tw-font-bold tw-text-[15px]"
        >
          I agree to the above terms
        </span>
      </div>

      <p class="tw-text-[15px] tw-text-[#D83A19] tw-mt-[15px]">Please check the box</p>

    </div>
  </form>

  <div
    [hidden]="!showDepositForm || (pendingList$ | async) | isEmpty"
    class="pending-deposit-list tw-mt-[50px]"
  >
    <p class="label tw-text-[16px]">Pending</p>

    <ion-grid class="table tw-mt-[20px]">
      <ion-row class="table-header">
        <ion-col class="tw-font-bold tw-text-[15px]">Date</ion-col>
        <ion-col class="tw-font-bold tw-text-[15px]">Amount</ion-col>
      </ion-row>

      <ion-row *ngFor="let item of pendingList$ | async; let i = index" class="table-row">
        <ion-col
          class="tw-text-[12px]"
        >
          {{ item.Date | dateFormat: 'MMMM DD, YYYY' }}
        </ion-col>
        <ion-col
          class="tw-text-[12px]"
        >
          {{ item.Amount | number:'1.2' }}
        </ion-col>
      </ion-row>
    </ion-grid>

    <!-- <ion-list>
      <ion-item *ngFor="let item of pendingList$ | async; let i = index">
        <ion-label>
          <p class="tw-text-[15px]">
            <span class="tw-font-bold">Date: </span>{{ item.Date | dateFormat: 'MMMM DD, YYYY' }}
          </p>
          <p class="tw-text-[15px]">
            <span class="tw-font-bold">Amount: $</span>{{ item.Amount | number:'1.2' }}
          </p>
        </ion-label>
      </ion-item>
    </ion-list> -->
  </div>

  <feature-ion-add-account
    [hidden]="!showAddAccountForm"
    (showAddAccountFormFn)="closeAddAccountForm($event)"
  >
  </feature-ion-add-account>
</section>
